import './styles.scss';
import { useState, useEffect, useRef } from 'react';

import avatar1 from '../../assets/customers/avatar-01.png';
import avatar2 from '../../assets/customers/avatar-02.png';
import avatar3 from '../../assets/customers/avatar-03.png'; 
import avatar4 from '../../assets/customers/avatar-04.png';
import avatar5 from '../../assets/customers/avatar-05.png';
import avatar6 from '../../assets/customers/avatar-06.png';
import avatar7 from '../../assets/customers/avatar-07.png';
import avatar8 from '../../assets/customers/avatar-08.png';

const avatars = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6, avatar7, avatar8];

export default function AvatarsRow() {
    const [balloons, setBalloons] = useState([]);
    const recentAvatarsRef = useRef([]);

    useEffect(() => {
        let timeoutId;

        const createBalloon = () => {
            // Filtra avatares que não foram usados recentemente (últimos 2)
            const availableAvatars = avatars.filter(avatar => 
                !recentAvatarsRef.current.includes(avatar)
            );
            
            // Se todos os avatares foram usados recentemente, usa todos
            const avatarPool = availableAvatars.length > 0 ? availableAvatars : avatars;
            
            const randomAvatar = avatarPool[Math.floor(Math.random() * avatarPool.length)];
            
            // Atualiza a lista de avatares recentes (mantém apenas os últimos 2)
            recentAvatarsRef.current = [
                ...recentAvatarsRef.current.slice(-2), // Mantém os últimos 2
                randomAvatar // Adiciona o novo
            ].slice(-2); // Garante que mantém apenas os últimos 2

            const initialSize = Math.random() * (12 - 18) + 10; // 10px a 20px
            const finalSize = Math.random() * (80 - 60) + 30; // 60px a 80px
            const finalY = -(Math.random() * (120 - 80) + 80); // -80px a -120px
            const initialX = Math.random() * (20 - (-20)) + (-30); // -0px a 20px
            const id = Date.now() + Math.random();

            setBalloons(prev => [...prev, {
                id,
                avatar: randomAvatar,
                initialSize,
                finalSize,
                finalY,
                initialX
            }]);

            // Remove o balão após a animação (assumindo duração de 2s)
            setTimeout(() => {
                setBalloons(prev => prev.filter(balloon => balloon.id !== id));
            }, 2000);

            // Próximo balão em intervalo aleatório entre 2s e 3s
            const nextInterval = Math.random() * (3000 - 2000) + 500;
            timeoutId = setTimeout(createBalloon, nextInterval);
        };

        // Inicia a primeira animação após um pequeno delay
        timeoutId = setTimeout(createBalloon, 2000);

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);

    return (
        <div className="avatars-badge">
            <div className="avatars">
                <img src={avatar1} alt="Avatar" />
                <img src={avatar2} alt="Avatar" />
                <img src={avatar3} alt="Avatar" />
                
                {/* Balões animados */}
                {balloons.map(balloon => (
                    <div
                        key={balloon.id}
                        className="balloon"
                        style={{
                            '--initial-size': `${balloon.initialSize}px`,
                            '--final-size': `${balloon.finalSize}px`,
                            '--final-y': `${balloon.finalY}px`,
                            '--initial-x': `${balloon.initialX}px`
                        }}
                    >
                        <img src={balloon.avatar} alt="Avatar balão" />
                    </div>
                ))}
            </div>

            <span>+ de <span className="text-linear-animated bold">3.700 pessoas</span> já estão no Ginastee</span>
        </div>
    )
}